  <main class="flex h-dvh w-screen flex-col items-center grow">
    <div class="flex h-dvh w-screen flex-col items-center grow">
      @if(isAuthenticated()) {
        <app-update-bar></app-update-bar>
        <router-outlet></router-outlet>
      }
    </div>
  </main>
